import { render } from "./App.vue?vue&type=template&id=5bd0f1fe&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5bd0f1fe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd0f1fe"]])

export default __exports__